import LayoutField from 'component/element/workdoc/layout/form-layout'
import InputNumber from 'component/element/InputNumber'
export const DEFAULT_SCHEMA = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        brand: {type: 'string', title: 'ยี่ห้อ', default: ''},
        model: {type: 'string', title: 'รุ่น', default: ''},
        vehicle_registration_no: {type: 'string', title: 'หมายเลขทะเบียน', default: ''},
        vehicle_type: {type: 'string', title: 'ประเภท', default: ''},
        cost_per_unit: {type: 'string', title: 'ราคาต้นทุน', default: ''}
    }    
}

export const DEFAULT_UI_SCHEMA = {
    'ui:field': LayoutField,
    'ui:layout': [
        [
            {name: 'brand', props: {md: 6}},
            {name: 'model', props: {md: 6}}
        ],
        [
            {name: 'vehicle_registration_no', props: {md: 6}},
            {name: 'vehicle_type', props: {md: 6}}
        ],
        [
            {name: 'cost_per_unit', props: {md: 6}}
        ]     
    ],
    cost_per_unit: {'ui:field': InputNumber}
}


// WEBPACK FOOTER //
// ./src/view/tyre/AssetVehicleGenFormSchema.js